import {
  PickupCRROTWV2Agent,
    PickupCRROTWV2Courier,
  PickupCRROTWV2Group,
  PickupCRROTWV2ShipmentDetail,
} from '@/domain/entities/Pickup'

/** Session snapshot for GENESIS-11350 Mark as Done by task group (survives in-memory store edge cases). */
export const CRROTW_MARK_DONE_GROUP_STORAGE_KEY =
  'pickup_crrotw_mark_done_task_group_v1'

export const CRROTW_CANCEL_GROUP_STORAGE_KEY = 'pickup_crrotw_cancel_task_group_v1'

export interface CrrotwMarkDoneGroupSerialized {
  taskGroupId: number
  senderName: string
  senderAddress: string
  senderPhone: string
  shipments: Array<{
    shipmentId: string
    productType: string
    quantity: number
  }>,
  latitude: number,
  longitude: number
}

export interface CrrotwCancelGroupSerialized {
  taskGroupId: number
  senderName: string
  senderAddress: string
  shipmentType: string
  senderPhone: string
  courier: PickupCRROTWV2Courier
  agent: PickupCRROTWV2Agent
  expiredAt: string
  shipments: Array<{
    shipmentId: string
    productType: string
    quantity: number
  }>
  latitude: number
  longitude: number
}


export function serializeCrrotwGroupForMarkDone(
  g: PickupCRROTWV2Group
): CrrotwMarkDoneGroupSerialized {
  return {
    taskGroupId: g.taskGroupId,
    senderName: g.senderName,
    senderAddress: g.senderAddress,
    senderPhone: g.senderPhone,
    shipments: g.shipments.map(s => ({
      shipmentId: s.shipmentId,
      productType: s.productType,
      quantity: s.quantity,
    })),
    latitude: g.latitude,
    longitude: g.longitude
  }
}

export function serializeCrrotwGroupForCancel(
  g: PickupCRROTWV2Group
): CrrotwCancelGroupSerialized {
  return {
    taskGroupId: g.taskGroupId,
    senderName: g.senderName,
    senderAddress: g.senderAddress,
    courier: g.courier,
    agent: g.agent,
    senderPhone: g.senderPhone,
    expiredAt: g.expiredAt,
    shipmentType: g.shipmentType,
    shipments: g.shipments.map(s => ({
      shipmentId: s.shipmentId,
      productType: s.productType,
      quantity: s.quantity,
    })),
    latitude: g.latitude,
    longitude: g.longitude
  }
}

/** Corporate / CP groups — hide bulk & row "Transfer pickup" per GENESIS-11347 */
export function isCorporateCrrotwShipmentType(shipmentType: string): boolean {
  const s = String(shipmentType || '')
    .toLowerCase()
    .trim()
  return s === 'corporate' || s.startsWith('cp')
}

/** Defensive ASC sort for embedded modal list; aligns with BE shipment_id ordering (GENESIS-11348). */
export function comparePickupCrrotwShipmentIdAsc(
  a: PickupCRROTWV2ShipmentDetail,
  b: PickupCRROTWV2ShipmentDetail
): number {
  const sa = String(a.shipmentId ?? '')
  const sb = String(b.shipmentId ?? '')
  const na = /^\d+$/.test(sa)
  const nb = /^\d+$/.test(sb)
  if (na && nb) {
    if (sa.length !== sb.length) return sa.length - sb.length
    return sa < sb ? -1 : sa > sb ? 1 : 0
  }
  return sa.localeCompare(sb, undefined, { numeric: true, sensitivity: 'base' })
}
